export default {
  ACCOUNT: '/account',
  HOME: '/',
  PASSWORD_CHANGE: '/update-password',
  PASSWORD_RESET: '/reset-password',
  REPORTS: '/reports',
  SIGN_IN: '/sign-in',
  SIGN_UP: '/sign-up',
}



// WEBPACK FOOTER //
// ./src/constants/paths.js